import { AuthMethod, AuthMethodId } from './Auth.interface';

export const authMethod: Record<AuthMethodId, AuthMethod> = {
  default: {
    id: AuthMethodId.Default,
    name: 'SierraQMS',
    image: '/logo-192.png'
  },
  google: {
    id: AuthMethodId.Google,
    name: 'Google',
    image: '/assets/auth/auth-google.svg'
  },
  okta: {
    id: AuthMethodId.Okta,
    name: 'Okta',
    image: '/assets/auth/auth-okta.svg'
  }
};
